import { Transaction } from '../abstract/transaction.model';
import { CashTransactionAllocation } from './cash-transaction-allocation.model';
import { TransactionDirectionEnum } from 'src/app/@shared/enums/transaction-direction.enum';

export class CashTransaction extends Transaction {

    static override CLASS_NAME: string = 'CashTransaction';

    private _comment!: string;
    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public getAmountClass(): string {
        if (this.type?.debitCredit === TransactionDirectionEnum.Credit) {
            return 'text-green-500';
        } else {
            return 'text-red-500';
        }
    }

    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/

    public get allocations(): CashTransactionAllocation[] {
        return this._allocations as CashTransactionAllocation[];
    }

    public set allocations(value: any) {
        this._setValue('_allocations', value, 'CashTransactionAllocation');
    }

    public get comment(): string {
        return this._comment;
    }

    public set comment(value: any) {
        this._setValue('_comment', value, 'string');
    }

}
